import { COLMAPCamerasData, COLMAPPoints3DData } from '@/types/colmap'
import { useAppStore } from '@/store/appStore'
import { resolveUrl } from '@/config'

export async function loadCOLMAPData(shopId: string): Promise<{
  cameras: COLMAPCamerasData
  points3d: COLMAPPoints3DData
}> {
  // Get base path from dataset configuration to support folder organization (e.g., NewShops/)
  const dataset = useAppStore.getState().availableDatasets.find(d => d.id === shopId)
  const basePath = dataset?.paths?.metadata?.replace('/shop_metadata.json', '') || `/api/scan-data/${shopId}`
  
  try {
    // Load cameras.json
    const camerasResponse = await fetch(resolveUrl(`${basePath}/cameras.json`))
    if (!camerasResponse.ok) {
      throw new Error(`Failed to load cameras.json: ${camerasResponse.statusText}`)
    }
    const cameras = await camerasResponse.json() as COLMAPCamerasData
    
    // Load points3d.json
    const pointsResponse = await fetch(resolveUrl(`${basePath}/points3d.json`))
    if (!pointsResponse.ok) {
      throw new Error(`Failed to load points3d.json: ${pointsResponse.statusText}`)
    }
    const points3d = await pointsResponse.json() as COLMAPPoints3DData
    
    return { cameras, points3d }
  } catch (error) {
    console.error('Error loading COLMAP data:', error)
    throw error
  }
}

export function getFrameImagePath(shopId: string, frameFile: string, framesPath?: string): string {
  // Use provided framesPath (for sections) or default to shop frames directory
  let path = framesPath
  if (!path) {
    // Get base path from dataset configuration to support folder organization (e.g., NewShops/)
    const dataset = useAppStore.getState().availableDatasets.find(d => d.id === shopId)
    const datasetBasePath = dataset?.paths?.metadata?.replace('/shop_metadata.json', '') || `/api/scan-data/${shopId}`
    path = `${datasetBasePath}/frames`
  }
  // Add shopId as query parameter for cache busting
  // This ensures browser doesn't serve cached images from different shops
  return `${resolveUrl(path)}/${frameFile}?shop=${shopId}`
}
